
















import { Vue, Component, Prop } from 'vue-property-decorator';
import { IframeBlockViewModel } from '@/types/contentServerContract';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';

@Component({
    components: { SmartHeadline }
})
export default class IframeBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: IframeBlockViewModel;

    @Prop({
        required: false,
        type: Boolean,
        default: false
    }) isFirstBlock!: boolean;
}
